export default {"src":"/_next/static/media/setting-gear-mod.eb788cca.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};